import validate from './UserGroupAddFormValidation';
import UseForm from "@usas/ui-web/utils/UseForm";
import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_FORM_STATE = {
  userGroup: [],
  orgUnitId: '',
  orgUnitName: '',
  lscOrgUnitId: Constants.DEFAULT_ID,
  memberId: '',
  offeringInstanceId: Constants.DEFAULT_ID,
  useRenewalFee: undefined
};

const useUserGroupAddForm = (onSubmitFormCallback, memberId) => {
  const { formState, errorState, handleSubmit, updateFormState, onValueTextPairChanged, onFormValueChanged, setFormData
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  return {
    formState,
    errorState,
    handleSubmit,
    setFormData,
    updateFormState,
    onValueTextPairChanged,
    onFormValueChanged,
    isNewClubApplication: formState.userGroup.findIndex(x => x.id === 29) > -1,
  };
};

export default useUserGroupAddForm;